import { flatten, unflatten } from 'flat'
import { deepMergeTwo } from './deepMerge'

const redactValuesFromObject = (
  object,
  valuesToRedact,
  { redactString = '######', mutate = false } = {},
) => {
  const flatObject = flatten(object)
  const lowerCasedValuesToRedact = valuesToRedact.map((item) => item.toLowerCase().trim())
  const redactedFlatObjectEntries = Object.entries(flatObject).map(([key, value]) => {
    const shouldValueBeRedacted = key.split('.').some((item, index, array) => {
      const isLast = index === array.length - 1
      if (!isLast) {
        return false
      }
      const shouldRedact = lowerCasedValuesToRedact.includes(item.toLocaleLowerCase().trim())
      return shouldRedact
    })
    if (shouldValueBeRedacted) {
      return [key, redactString]
    }
    return [key, value]
  })
  const redactedFlatObject = Object.fromEntries(redactedFlatObjectEntries)
  const redactedObject = unflatten(redactedFlatObject)

  if (mutate) {
    deepMergeTwo(object, redactedObject, { mutate })
    return object
  }

  return redactedObject
}

const valuesToRedactFromLogs = (process.env.LOGGER_REDACT_WORDS ?? '')
  .split(',')
  .map((item) => item.toLowerCase().trim())

/**
 * A function to redact (masking sensitive) values from logs
 * @param {*} object Object to redact values from
 * @param {*} extraValuesToRedact Extra values to redact
 * @returns Redacted object
 */
const redactValuesFromLogs = (object, extraValuesToRedact) =>
  redactValuesFromObject(object, [...valuesToRedactFromLogs, ...(extraValuesToRedact ?? [])], {
    mutate: true,
    redactString: 'REDACTED',
  })

export { redactValuesFromLogs }
